import React from 'react';
import _ from 'lodash';

import {
  Grid,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  styled
} from '@mui/material';
import {
  People,
  Storefront
} from '@mui/icons-material';
import {
  PermissionWall,
  activityTemplates,
  useTabSearchParams
} from 'modules';

import { useParams } from 'react-router-dom';
import * as BrandTab from './BrandTab/BrandTab';
import * as UsersTab from './UsersTab/UsersTab';



const TabGrid = styled(Grid)(({ theme }) => ({
  marginTop: theme.spacing(2),
  padding: theme.spacing(2)
}));



export const StoreSettingsActivity: React.FC = () => {
  const [tabId, setTabId] = useTabSearchParams({
    defaultTabId: 'base',
    paramName: 'tabId'
  });
  const params = useParams<{ storeId: string; }>();



  function handleClickTab(tabId: string) {
    setTabId(tabId);
  }



  return !params.storeId ? null : (
    <activityTemplates.PartnerActivityTemplate.FC storeId={params.storeId}>
      <Grid container spacing={1}>
        <Grid item xs={2}>
          <List>
            <PermissionWall.FC
              storeId={params.storeId}
              requiresPermissions={[
                'user_invite',
                'user_view',
                'user_viewInvites'
              ]}>
              <ListItem>
                <ListItemButton
                  selected={tabId === 'users'}
                  onClick={_.partial(handleClickTab, 'users')}>
                  <ListItemIcon>
                    <People />
                  </ListItemIcon>

                  <ListItemText primary="Users" />
                </ListItemButton>
              </ListItem>
            </PermissionWall.FC>

            <PermissionWall.FC
              storeId={params.storeId}
              requiresPermissions={[
                'store_updateBrand'
              ]}>
              <ListItem>
                <ListItemButton
                  selected={tabId === 'brand'}
                  onClick={_.partial(handleClickTab, 'brand')}>
                  <ListItemIcon>
                    <Storefront />
                  </ListItemIcon>

                  <ListItemText primary="Brand" />
                </ListItemButton>
              </ListItem>
            </PermissionWall.FC>
          </List>
        </Grid>

        <TabGrid item xs={10}>
          {tabId === 'brand' && (
            <BrandTab.FC storeId={params.storeId ?? ''} />
          )}

          {tabId === 'users' && (
            <UsersTab.FC storeId={params.storeId ?? ''} />
          )}
        </TabGrid>
      </Grid>
    </activityTemplates.PartnerActivityTemplate.FC>
  );
};
